import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export const ReminderToViewCategory = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1}>
        <Typography>{t('share_document_v3.automatic_reminders.send')}</Typography>
        <Autocomplete
          size="small"
          sx={{
            width: '100%',
          }}
          options={[]}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('share_document_v3.automatic_reminders.automatic_reminder_to_view.view_reminder_default_template')}
            />
          )}
        />
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography>{t('share_document_v3.automatic_reminders.automatic_reminder_to_view.if_contact_hasnt_viewed_after')}</Typography>
        <TextField value={1} size="small" type="number" sx={{ width: 40 }} />
        <Typography>{t('share_document_v3.automatic_reminders.days')}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1}>
        <Typography>{t('share_document_v3.automatic_reminders.automatic_reminder_to_view.send_every')}</Typography>
        <TextField value={1} size="small" type="number" sx={{ width: 40 }} />
        <Typography>{t('share_document_v3.automatic_reminders.days')}</Typography>
        <Typography>{t('share_document_v3.automatic_reminders.automatic_reminder_to_view.days_until_viewed')}</Typography>
      </Stack>
    </Stack>
  );
};
